import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const FailPage = () => {
  const navigate = useNavigate();
  const [failReason, setFailReason] = useState('');

  useEffect(() => {
    // URL에서 실패 사유 파라미터(message)를 가져옵니다.
    const searchParams = new URLSearchParams(window.location.search);
    const reason = searchParams.get('message');
    if (reason) {
      // URL 인코딩된 문자열을 디코딩하여 state에 저장합니다.
      setFailReason(decodeURIComponent(reason));
    }

    const cancelPayment = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const customerKey = searchParams.get('customer_key');

      if (customerKey) {
        try {
          await api.delete('payments/cards/request/', {
            data: {
              customer_key: customerKey
            }
          });
        } catch (error) {
          console.error('정기 결제 삭제 실패:', error);
        }
      }
    };

    cancelPayment();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">카드 등록에 실패했습니다</h2>
          <p className="text-lg text-gray-600 mb-8">
            카드 등록 중 문제가 발생했습니다.<br />
            다시 시도해 주세요.
          </p>

          {failReason && (
            <div className="text-left bg-red-50 border border-red-200 p-4 rounded-lg mb-6">
              <p className="text-sm text-red-800">
                <span className="font-semibold">실패 사유:</span> {failReason}
              </p>
            </div>
          )}

          <div className="space-y-4">
            <button
              onClick={() => navigate('/pricing')}
              className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
            >
              요금제 선택으로 돌아가기
            </button>
            <button
              onClick={() => window.location.href = `${process.env.REACT_APP_APP_DOMAIN}/workspaces`}
              className="w-full px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors"
            >
              공간으로 이동
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FailPage;